import React from 'react';
import Opportunities_Comp from '../../Components/Opportunities/Opportunities';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function Opportunities() {
  return (
    <Dashboard_Comp>
    <Opportunities_Comp />
    </Dashboard_Comp>
  )
}

export default Opportunities;